<div class="emds">
  <div class="form-group" [formGroup]="formGroupInstance" [ngClass]="{ 'required': isRequired() }">
    <label *ngIf="showLabel" translate>{{ labelName }}</label>
    <div
      class="input-group"
      [ngClass]="{ 'required-invalid': (!!form ? form?.submitted : formGroupSubmitted) && error }"
    >
      <input
        #datePicker="bsDatepicker"
        bsDatepicker
        class="ap-datepicker-select form-control"
        id="{{ id }}-input"
        type="text"
        (keypress)="validateCharacter($event)"
        (ngModelChange)="onChange($event)"
        formControlName="{{controlName}}"
        [bsConfig]="bsConfig"
        [dateCustomClasses]="dateCustomClasses"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [ngClass]="{'required-field': required }"
        [ngStyle]="onApplyDatePickerStyle()"
      />
      <span class="input-group-btn input-group-append">
        <button
          type="button"
          class="ap-datepicker-date-btn btn btn-default btn-flush"
          id="{{ id }}-button"
          [disabled]="disabled"
          (click)="datePicker.toggle()"
        >
          <i class="glyphicon glyphicon-calendar ap-datepicker-date-icon"></i>
        </button>
      </span>
    </div>
    <div class="incorrect-input" *ngIf="(!!form ? form?.submitted : formGroupSubmitted) && error">
      {{ error }}
    </div>
  </div>
</div>
